import { Injectable } from '@angular/core';
import { ApiUserScope } from '@client/app/feature-modules/admin/modules/admin-api-tokens/types/api-user.type';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class ApiTokensService {
    private readonly scopes: ApiUserScope[] = [
        'cms',
        'customer',
        'customer_admin',
    ];
    private readonly scopesTranslationMap: Map<ApiUserScope, string> = new Map<ApiUserScope, string>();

    constructor (
        private readonly translocoService: TranslocoService,
    ) {
        this.scopesTranslationMap.set('cms', this.translocoService.translate('adminApiTokens.scope.cms'));
        this.scopesTranslationMap.set('customer', this.translocoService.translate('adminApiTokens.scope.customer'));
        this.scopesTranslationMap.set('customer_admin', this.translocoService.translate('adminApiTokens.scope.customerAdmin'));
    }

    getScopes (): ApiUserScope[] {
        return this.scopes;
    }

    getScopesTranslationMap (): Map<ApiUserScope, string> {
        return this.scopesTranslationMap;
    }
}
